export interface CriticalSessionDescriptor {
  id: string;
  type: string;
  started_at: string;
  durable_checkpoint: boolean;
}

type Listener = (sessions: CriticalSessionDescriptor[]) => void;
const sessions = new Map<string, CriticalSessionDescriptor>();
const listeners = new Set<Listener>();

function emit() { const value = [...sessions.values()]; listeners.forEach(fn => { try { fn(value); } catch {} }); }

export function registerCriticalSession(session: CriticalSessionDescriptor): () => void {
  sessions.set(session.id, session); emit();
  return () => { sessions.delete(session.id); emit(); };
}
export function updateCriticalSession(id: string, patch: Partial<CriticalSessionDescriptor>): void {
  const current = sessions.get(id); if (!current) return;
  sessions.set(id, { ...current, ...patch }); emit();
}
export function activeCriticalSessions(): CriticalSessionDescriptor[] { return [...sessions.values()]; }
export function hasActiveCriticalSession(): boolean { return sessions.size > 0; }
export function subscribeCriticalSessions(listener: Listener): () => void { listeners.add(listener); return () => listeners.delete(listener); }
